import { inject, InjectionToken } from '@angular/core';
import { GuideService } from './guide.service';
import { GuideServiceProvider } from './types';

/**
 * An injection token for the guide service.
 */
export const GUIDE_SERVICE = new InjectionToken<GuideServiceProvider>('GUIDE_SERVICE', {
   providedIn: 'root',
   factory: () => inject(GuideService),
});
